import { Eye } from "lucide-react";
import { CombinedLevel } from "../../../../../Redux/referral/types";
import { earningsStatusClass } from "../../earningsAdapters";

interface Props {
  levels: CombinedLevel[];
  orderNo: string;
}

const CombinedLevelsTable = ({ levels, orderNo }: Props) => {
  return (
    <div className="ri-table-wrap ri-flow-network-table-wrap">
      <table className="ri-table ri-flow-network-table">
        <thead>
          <tr>
            <th>LEVEL</th>
            <th>PRODUCT NAME</th>
            <th>REQUIRED NO</th>
            <th>JOINED MEMBERS</th>
            <th>COMMISSIONS</th>
            <th>STATUS</th>
            <th>NETWORK VIEW</th>
          </tr>
        </thead>
        <tbody>
          {levels?.map((level, index) => (
            <tr key={index}>
              <td className="ri-center">
                <strong>Level - {level.level}</strong>
              </td>
              <td>
                <div className="ri-product-copy">
                  <strong>{level.productName}</strong>
                  {level.isAutoUpgrade && <span>Auto Upgrade</span>}
                </div>
              </td>
              <td className="ri-center">
                <strong>{level.requiredNo}</strong>
              </td>
              <td className="ri-center">
                <strong>{level.joinedMembers}</strong>
              </td>
              <td className="ri-center">
                <strong className="ri-money">
                  ₹{level.commissions.toLocaleString("en-IN")}
                </strong>
              </td>
              <td className="ri-center">
                <span
                  className={earningsStatusClass(
                    level.isCompleted ? "Completed" : "Pending",
                  )}
                >
                  {level.isCompleted ? "Completed" : "Pending"}
                </span>
              </td>
              <td className="ri-center">
                <a
                  className="ri-view-button"
                  href={`/ReferralCommLevel?orderNo=${orderNo}&milestoneNo=${level.level}`}
                >
                  View
                  <Eye size={16} />
                </a>
              </td>
            </tr>
          ))}
          {(!levels || levels.length === 0) && (
            <tr>
              <td colSpan={7} className="ri-center">
                No level data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CombinedLevelsTable;
